<template>
  <div>
    <FilterOrganization :disable="true" @option="onOptionChange" :option="option"/>
    <Organization :caption="item.name" :org="(index,item)" v-for="item in agency" :key="index"  @node-click="onAddChart" @node-change="onChangeChart"/>
    <SearchProfile :isShow="isShow" @update="onDismiss" :object="nodeData"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Organization from "@/projects/views/E-Performances/Organization/index";
import SearchProfile from "@/projects/components/Dialog/SearchProfile";
import FilterOrganization from "@/projects/components/Filter/FilterOrganization";

export default {
  name: "OrganizationCharts",
  components: {FilterOrganization, SearchProfile, Organization},
  data: function () {
    return {
      agency:[],


      //
      isShow:false,
      nodeData:{
        children:[]
      },
      option:{
        organization: "66cbe802a41ed9362a8579fa",
        agency: 0,
        year: new Date().getFullYear() + 543,
      },
    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      // this.$store.dispatch("agency/config",{})
      this.onLoad();
    },

    onLoad() {
      var data = {};
      (this.option.agency != 0)?data.agency = this.option.agency:null;
      this.$store.dispatch("agencyChart/config",data)
    },

    onOptionChange(e){
      this.isShow = false;
      this.option = e;
      // this.onLoad();
    },

    onAddChart(e){
      this.nodeData = e;
      this.isShow = true;
    },


    onDismiss(){
      this.isShow = false;
    },

    onChangeChart(e){

    }

  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      agencyChart: 'agencyChart/item',
    })
  },

  watch: {

    agencyChart: function (value){
      value.filter(objs => {
        // if(objs.agency._id.toString() == this.$store.getters["personal/profile"].agency._id){
          objs.type = 0;
          objs.name = objs.agency.title.filter(title => {if (title.key == this.lang) { return title } })[0].value;
          return objs;
        // }
      })
      if( this.$store.getters["personal/profile"].role != 1){
        this.agency = value.filter(objs =>  { return (objs.agency._id.toString() == this.$store.getters["personal/profile"].agency._id)});
      }else{
        this.agency = value
      }

    },

    "option.organization"(value){
      this.onLoad()
    },

    "option.agency"(value){
      this.onLoad()
    },
  }
}
</script>

<style scoped>

</style>
